import React, { useState } from "react";
import Award from "./Award";
import "./awards.style.css";
import { AWARDS_DATA } from "./data";

const Awards = () => {
  const [viewMore, setViewMore] = useState(false);
  const [awardsData, setAwardsData] = useState(AWARDS_DATA.slice(0, 4));

  const handleViewMore = () => {
    const slicedData = !viewMore ? AWARDS_DATA : AWARDS_DATA.slice(0, 4);
    setAwardsData(slicedData);
    setViewMore((prevState) => !prevState);
  };

  return (
    <section
      id="awards"
      className="awards_main"
      itemScope
      itemType="https://schema.org/ItemList"
    >
      {/* Section metadata for SEO */}
      <meta itemProp="name" content="Awards and Achievements of Swagat Vyas" />
      <meta
        itemProp="description"
        content="Awards and recognitions received by Swagat Vyas and Vishwanath Builders"
      />

      <h1>Awards & Achievement</h1>

      <div className="awards">
        {awardsData.map((item, index) => (
          <div
            key={index}
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/Award"
          >
            <meta itemProp="name" content={item.title || "Award"} />
            <Award item={item} />
          </div>
        ))}
      </div>

      <p
        onClick={handleViewMore}
        role="button"
        aria-label={viewMore ? "View fewer awards" : "View more awards"}
        style={{
          textAlign: "center",
          marginTop: "25px",
          cursor: "pointer",
        }}
      >
        {viewMore ? "VIEW LESS" : "VIEW MORE"}
      </p>
    </section>
  );
};

export default Awards;
